import NumberInputCoreUI from './NumberInputCoreUI';

export default NumberInputCoreUI;
